import React from 'react'
import { H2 } from '../Heading/index'

/**
 * Displays a section highlighting key sub-value prop
 *
 * @param {Map} staticText - Text strings used in the component
 * @returns {JSX.Element} Sub-value feature block
 */
function SharePageSubValue (props) {
  const { staticText } = props

  return (
    <div className="share-page__sub-value">
      <div className="share-page__sub-value-overlay" />
      <div className="share-page__sub-value-content">
        <div className="share-page__sub-value-top">
          <div className="share-page__subtitle share-page__sub-value-subtitle">{staticText.get('subValueSubtitle')}</div>
          <H2 className="share-page__sub-value-title">{staticText.get('subValueTitle')}</H2>
        </div>
        <div className="share-page__sub-value-props">
          <div className="share-page__sub-value-prop">
            <div className="share-page__sub-value-prop-image share-page__sub-value-prop-image--groundbreaking" />
            <div className="share-page__sub-value-prop-subtitle">{staticText.get('subValuePropSubtitle1')}</div>
            <div className="share-page__sub-value-prop-title">{staticText.get('subValuePropTitle1')}</div>
            <div className="share-page__sub-value-prop-copy">{staticText.get('subValuePropCopy1')}</div>
          </div>
          <div className="share-page__sub-value-prop">
            <div className="share-page__sub-value-prop-image share-page__sub-value-prop-image--world-class" />
            <div className="share-page__sub-value-prop-subtitle">{staticText.get('subValuePropSubtitle2')}</div>
            <div className="share-page__sub-value-prop-title">{staticText.get('subValuePropTitle2')}</div>
            <div className="share-page__sub-value-prop-copy">{staticText.get('subValuePropCopy2')}</div>
          </div>
          <div className="share-page__sub-value-prop">
            <div className="share-page__sub-value-prop-image share-page__sub-value-prop-image--ad-free" />
            <div className="share-page__sub-value-prop-subtitle">{staticText.get('subValuePropSubtitle3')}</div>
            <div className="share-page__sub-value-prop-title">{staticText.get('subValuePropTitle3')}</div>
            <div className="share-page__sub-value-prop-copy">{staticText.get('subValuePropCopy3')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SharePageSubValue
